"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const basic_form_input_1 = __importDefault(require("../../../client/form_components/inputs/basic_form_input"));
const form_image_uploader_1 = __importDefault(require("../../../client/form_components/image_uploaders/form_image_uploader"));
const Form_1 = require("./Form");
const Overview = ({ errors, form, giveaway, handleUpdate, isSubmitting, setIsSubmitting, pendingChanges, }) => {
    const handleImageChange = ({ name, value, }) => {
        // disable save button while image starts upload.
        setIsSubmitting(true);
        handleUpdate({ name, value });
    };
    const handleImageUpload = ({ uploading }) => {
        // once status is false, we are no longer uploading
        setIsSubmitting(uploading);
    };
    return (react_1.default.createElement("div", { className: Form_1.c.container },
        react_1.default.createElement("p", { className: Form_1.c.subHeader }, "Overview"),
        react_1.default.createElement("div", { className: Form_1.c.form },
            react_1.default.createElement(basic_form_input_1.default, { disabled: isSubmitting, errors: errors?.title, label: "Title", name: "title", onChange: ({ target: { value } }) => handleUpdate({ name: 'title', value }), placeholder: "Epic AI Giveaway", value: pendingChanges.has('title') ? form.title : giveaway.title }),
            react_1.default.createElement(basic_form_input_1.default, { disabled: isSubmitting, errors: errors?.teaser, label: "Teaser (optional)", name: "teaser", onChange: ({ target: { value } }) => handleUpdate({ name: 'teaser', value }), placeholder: "Why should I enter this Giveaway?", value: pendingChanges.has('teaser') ? form.teaser : giveaway.teaser || '' }),
            react_1.default.createElement(form_image_uploader_1.default, { allowGifs: true, aspectRatio: 4 / 1, attachmentType: "CoverImage", errors: errors?.cover_image, helperText: "This image should have a ratio of 4:1 and be 4800x1200px (minimum 1600x400px) for the best quality.", imageData: {
                    id: pendingChanges.has('cover_image')
                        ? form.cover_image?.id
                        : giveaway.cover_image?.id,
                    url: pendingChanges.has('cover_image')
                        ? form.cover_image?.url
                        : giveaway.cover_image?.url,
                }, image_version: "cover_wide", label: "Banner Image", propagateStatus: handleImageUpload, propagateUpload: ({ id, url }) => handleImageChange({
                    name: 'cover_image',
                    value: { id, url },
                }) }),
            react_1.default.createElement(form_image_uploader_1.default, { allowGifs: true, aspectRatio: 343 / 163, attachmentType: "AlternateCoverImage", errors: errors?.alternate_cover_image, helperText: "This image should have a ratio of 21:10 and be 1890x900px (minimum 630x300px) for the best quality.", imageData: {
                    id: pendingChanges.has('alternate_cover_image')
                        ? form.alternate_cover_image?.id
                        : giveaway.alternate_cover_image?.id,
                    url: pendingChanges.has('alternate_cover_image')
                        ? form.alternate_cover_image?.url
                        : giveaway.alternate_cover_image?.url,
                }, image_version: "challenge_full_thumb", label: "Mobile Card Image", propagateStatus: handleImageUpload, propagateUpload: ({ id, url }) => handleImageChange({
                    name: 'alternate_cover_image',
                    value: { id, url },
                }) }))));
};
exports.default = Overview;
